<template>
  <div class="custom-nav-tabs">
    <b-tabs v-model="tabIndex" content-class="mt-3">
      <b-tab
        :title="$t('quick-access')"
        lazy
        v-if="!$store.getters['enums/is_not_permitted']('quickAccess')"
      >
        <QuickAccess />
      </b-tab>
      <b-tab
        :title="$t('noc')"
        lazy
        v-if="!$store.getters['enums/is_not_permitted']('NOC')"
      >
        <Dashboard />
      </b-tab>
      <b-tab
        :title="$t('gps-track')"
        lazy
        v-if="!$store.getters['enums/is_not_permitted']('NOC')"
      >
        <GPSTrack />
      </b-tab>
      <b-tab
        :title="$t('hajj-module')"
        lazy
        v-if="!$store.getters['enums/is_not_permitted']('hajjModule')"
      >
        <HajjModuleQuickAccess />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Dashboard from "@/components/Dashboard/index.vue";
import GPSTrack from "@/components/GPSTrack/index.vue";
import QuickAccess from "@/components/Dashboard/QuickAccess.vue";
import HajjModuleQuickAccess from "@/components/Dashboard/HajjModuleQuickAccess.vue";

export default {
  name: "dashboard",
  components: { Dashboard, GPSTrack, QuickAccess, HajjModuleQuickAccess },
  data() {
    return { tabIndex: 0 };
  },
  computed: {
    visibleTabKeys() {
      const keys = [];
      if (!this.$store.getters["enums/is_not_permitted"]("quickAccess")) keys.push("quick-access");
      if (!this.$store.getters["enums/is_not_permitted"]("NOC")) keys.push("noc");
      if (!this.$store.getters["enums/is_not_permitted"]("NOC")) keys.push("gps-track");
      if (!this.$store.getters["enums/is_not_permitted"]("hajjModule")) keys.push("hajj-module");
      return keys;
    },
  },
  created() {
    this.syncTabFromRoute();
  },
  watch: {
    "$route.params.view"() {
      this.syncTabFromRoute();
    },
    tabIndex() {
      this.syncRouteFromTab();
    },
  },
  methods: {
    syncTabFromRoute() {
      const view = this.$route.params.view;
      const idx = this.visibleTabKeys.findIndex((k) => k === view);
      this.tabIndex = idx >= 0 ? idx : 0;
    },
    syncRouteFromTab() {
      const key = this.visibleTabKeys[this.tabIndex] || this.visibleTabKeys[0] || "quick-access";
      if (this.$route.params.view === key) return;
      this.$router.replace({ name: "dashboard", params: { view: key } }).catch(() => {});
    },
  },
};
</script>
